// ABOUTME: Wallet icon for balance display and payment method selection.
// ABOUTME: Displays a wallet icon with configurable size, color, and className.

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const WalletIcon = ({ className = "", size = 20, color = "#6B7280" }: IconProps) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2"
      y="6"
      width="20"
      height="14"
      rx="2"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6"
      stroke={color}
      strokeWidth="1.5"
    />
    <circle
      cx="17"
      cy="13"
      r="1.5"
      fill={color}
    />
  </svg>
)
